// NavigationIcons.js

import AvatarICON from "../assets/avatar.json";
import StarICON from "../assets/star.json";
import ConversationICON from "../assets/conversation.json";
import CmdPromptICON from "../assets/cmd-prompt.json";
import ClockICON from "../assets/clock.json";

const NavigationIcons = {
  Avatar: AvatarICON,
  Star: StarICON,
  Conversation: ConversationICON,
  CmdPrompt: CmdPromptICON,
  Clock: ClockICON,
};

export default NavigationIcons;
